/**
 * A failed control's sentence, beside the control that failed.
 *
 * `FollowButton` and `CommentThread` already answer a refused request this way
 * — a footnote-sized line in the control's own box — and this is that markup
 * with the `role` baked in, so the attribute nobody sees cannot drift as the
 * pattern is repeated. `FormAlert` is the same idea at section size; use that
 * one when the failure is the whole section's rather than one control's.
 */
export default function InlineAlert({ children }) {
  if (!children) return null
  return (
    <p className="footnote error mb-0" role="alert">
      {children}
    </p>
  )
}
